var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.663,
    height: 20.608,
    viewBox: "0 0 20.663 20.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218",
    transform: "translate(-1636.256 -5394.582)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2217",
    "data-name": "Group 2217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M1647.667,5403.284c.286-.321.522-.648.816-.925a4.484,4.484,0,0,1,3.222-1.272,7.48,7.48,0,0,1,2.027.247,3.961,3.961,0,0,1,2.812,2.958,12.394,12.394,0,0,1,.374,3.388c0,2.409-.007,4.817,0,7.225,0,.226-.062.285-.284.283q-1.861-.015-3.723,0c-.218,0-.265-.066-.264-.272q.01-3.438,0-6.875a6.185,6.185,0,0,0-.2-1.707,1.919,1.919,0,0,0-2.11-1.5,2.306,2.306,0,0,0-2.424,2.3,8.559,8.559,0,0,0-.066,1.075c0,2.228,0,4.457.006,6.686,0,.222-.055.288-.282.286q-1.875-.016-3.749,0c-.2,0-.259-.053-.258-.255q.008-6.62,0-13.238c0-.219.072-.269.278-.268q1.781.014,3.561,0c.218,0,.274.068.27.275C1647.659,5402.229,1647.667,5402.757,1647.667,5403.284Z",
    fill: "#597931"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3593",
    "data-name": "Path 3593",
    d: "M1640.868,5408.327c0,2.183,0,4.366.005,6.549,0,.243-.059.316-.31.314-1.24-.014-2.481-.011-3.721,0-.2,0-.259-.049-.258-.254q.009-6.63,0-13.26c0-.183.044-.248.238-.247,1.258.008,2.517.011,3.775,0,.242,0,.275.091.274.3Q1640.863,5405.025,1640.868,5408.327Z",
    fill: "#597931"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M1641.21,5397.047a2.477,2.477,0,1,1-2.473-2.465A2.485,2.485,0,0,1,1641.21,5397.047Z",
    fill: "#597931"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.b2230e536d2b358f52f1e4e897cc9530.svg";
export { ForwardRef as ReactComponent };